import { render, staticRenderFns } from "./roomintroduction.vue?vue&type=template&id=6e89261f&scoped=true&"
import script from "./roomintroduction.vue?vue&type=script&lang=js&"
export * from "./roomintroduction.vue?vue&type=script&lang=js&"
import style0 from "./roomintroduction.vue?vue&type=style&index=0&id=6e89261f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e89261f",
  null
  
)

export default component.exports